import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'splitStringByChar' })
export class SplitStringByCharPipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {string} value
     * @param {string} arg
     * @returns {string}
     */
    transform(value: string, arg: string): any {
        if (value) {
            console.warn('value', value);
            console.warn('arg', arg);
            const splitted = value.split(arg).join('\r\n');
            // const re = new RegExp(arg , 'g');
            // const splitted = value.replace(/\u21B5/g, '<br/>');
            console.warn('splitted', splitted);
            return splitted;
        }
        else { return null; }
    }
}
